(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-comparison-slider"] && !Shopify.designMode) return;
  try {
    
  const initialiseCiarelleComparisons = (scope = document) => {
    scope
      .querySelectorAll('[data-ciarelle-comparison]')
      .forEach((comparison) => {
        if (comparison.dataset.initialised === 'true') return;

        comparison.dataset.initialised = 'true';

        const range = comparison.querySelector(
          '.ciarelle-comparison__range'
        );

        let animationTimers = [];

        const update = () => {
          comparison.style.setProperty(
            '--position',
            `${range.value}%`
          );
        };

        const stopAnimation = () => {
          animationTimers.forEach((timer) => {
            clearTimeout(timer);
          });

          animationTimers = [];

          comparison.style.setProperty(
            '--comparison-transition',
            '0s'
          );
        };

        range.addEventListener('input', () => {
          stopAnimation();
          update();
        });

        update();

        if (
          comparison.dataset.animate === 'true' &&
          'IntersectionObserver' in window
        ) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                observer.disconnect();

                if (
                  window.matchMedia(
                    '(prefers-reduced-motion: reduce)'
                  ).matches
                ) return;

                comparison.style.setProperty(
                  '--comparison-transition',
                  '0.5s'
                );

                animationTimers.push(
                  setTimeout(() => {
                    comparison.style.setProperty(
                      '--position',
                      '40%'
                    );
                  }, 400)
                );

                animationTimers.push(
                  setTimeout(() => {
                    comparison.style.setProperty(
                      '--position',
                      '60%'
                    );
                  }, 900)
                );

                animationTimers.push(
                  setTimeout(() => {
                    comparison.style.setProperty(
                      '--position',
                      '50%'
                    );
                  }, 1400)
                );

                animationTimers.push(
                  setTimeout(() => {
                    comparison.style.setProperty(
                      '--comparison-transition',
                      '0s'
                    );

                    range.value = '50';
                  }, 1900)
                );
              });
            },
            {
              threshold: 0.5
            }
          );

          observer.observe(comparison);
        }
      });
  };

  initialiseCiarelleComparisons();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseCiarelleComparisons(event.target);
    }
  );

  } catch(e) { console.error(e); }
})();
})();
